import React, { Suspense, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import ProjectLayout from "../ProjectLayout";
import ErrorBoundary from "../ErrrorBoundry";
import { getLocalStorageItem } from "../Utils";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";

function ProtectedAuth() {
  const location = useLocation();
  const profileDetail = useSelector((state) => state.B2B.profileDetail);
  const navigate = useNavigate();
  const isAuthenticated = () => {
    const user = getLocalStorageItem("isLoggedIn");
    return user;
  };
  // useEffect(() => {
  //   if (
  //     location.pathname !== "/kycStatus" &&
  //     location.pathname !== "/Report/wallet" &&
  //     location.pathname !== "/dashboard" &&
  //     location.pathname !== "/fundRequest" &&
  //     location.pathname !== "/addFund" &&
  //     location.pathname !== "/personal-info" &&
  //     location.pathname !== "/Report/fund-request" &&s
  //     (profileDetail.digio_kyc === "0" ||
  //       profileDetail.digio_kyc === "2" ||
  //       profileDetail.digio_kyc === "3")
  //   ) {
  //     navigate("/kycStatus");
  //   }
  // }, [location]);
  useEffect(() => {
    const allowedRoutesWithoutKyc = [
      "/kycStatus",
      "/Report/wallet",
      "/dashboard",
      "/fundRequest",
      "/addFund",
      "/personal-info",
      "/Report/fund-request",
      "/not-available",
    ];

    const isKycPending =
      profileDetail.digio_kyc === "0" ||
      profileDetail.digio_kyc === "2" ||
      profileDetail.digio_kyc === "3";

    if (!allowedRoutesWithoutKyc.includes(location.pathname) && isKycPending) {
      navigate("/kycStatus");
    }
  }, [location.pathname, profileDetail]);
  return isAuthenticated() ? (
    <>
      {" "}
      <Suspense
        fallback={
          <div className="p-4">
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
            <Skeleton active className="mt-2" />
          </div>
        }
      >
        <ProjectLayout>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </ProjectLayout>
      </Suspense>
    </>
  ) : (
    <>
      <Navigate to="/" replace />
    </>
  );
}
export default ProtectedAuth;
